<template>
  <div v-if="model" class="invite-control text-big">
    <transition name="invite-control-tab-transition" mode="out-in">
      <div
        class="invite-control-fadeable"
        key="abc"
        v-if="serverSendTab == true && model.allowServerSend"
      >
        <p>
          Type in the {{ hasAddressBook ? "names or" : "" }} email addresses of
          {{ model.peoplePhrase }}. If you want, you can also
          <a href="javascript:void(0)" @click="serverSendTab = false"
            >send them an invitation link yourself</a
          >.
        </p>
        <user-invite-sender
          :user-tags="model.userTags"
          :sendUrl="model.sendUrl"
          :show-examples="showExamples"
          @send-started="onSendEvent(emitInviteAction)"
        />

        <div style="height: 10px"></div>
      </div>
      <div class="invite-control-fadeable" key="def" v-else>
        <p>
          Send this personalised link to {{ model.peoplePhrase }}.
          <span v-if="model.allowServerSend">
            We can also
            <a href="javascript:void(0)" @click="serverSendTab = true"
              >send the link in an email for you</a
            >.
          </span>
        </p>

        <div style="height: 5px"></div>
        <div>
          <input
            type="text"
            ref="inviteLink"
            @click="selectCodeUrl()"
            class="form-control input-lg invite-link-input selectAllOnClick"
            id="inviteLink"
            style="cursor: auto; max-width: unset"
            readonly="readonly"
            :value="model.inviteUrl"
            @copy="onCopyLink(emitInviteAction, props.model ?? undefined)"
            aria-label="Invite link"
          />
        </div>
        <div style="height: 5px"></div>
        <div style="text-align: right; display: flex; justify-content: flex-end">
          <span
            style="position: relative; top: 10px; left: -10px; float: left"
            :style="{ opacity: copied ? 0.8 : 0, transition: 'opacity 0.5s' }"
            >Copied...
          </span>
          <button
            class="btn btn-default-copy btn-lg"
            @click="copyToClipboard(emitInviteAction)"
            type="button"
          >
            Copy link
          </button>
        </div>
      </div>
    </transition>
    <div v-if="model.continueButtonUrl && model.showContinueButton">
      <form :action="model.continueButtonUrl" method="post" style="text-align: right">
        <input
          type="submit"
          style="display: inline-block"
          :value="model.continueButtonText"
          class="btn btn-default btn-lg"
        />
      </form>
    </div>
  </div>
</template>
<script setup lang="ts">
import UserInviteSender from "./user-invite-sender.vue";
import useInviteControlBase from "./useInviteControlBase";
import type { InviteControlApiModel } from "../../api-models";

const props = withDefaults(
  defineProps<{
    model: InviteControlApiModel | null;
    showExamples?: boolean;
  }>(),
  {
    model: null,
    showExamples: false,
  },
);

const emit = defineEmits(["invite-action"]);

const {
  copied,
  serverSendTab,
  copyToClipboard,
  onCopyLink,
  onSendEvent,
  hasAddressBook,
  selectCodeUrl,
} = useInviteControlBase(props.model);

function emitInviteAction() {
  emit("invite-action");
}

function onDeletedEvent() {
  // Nothing to do here
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.invite-control-tab-transition-enter,
.invite-control-tab-transition-leave-to {
  opacity: 0;
}

.invite-control-fadeable {
  transition: opacity 0.5s;
}

.invite-link-input {
  max-width: 100%;
}

.invite-code-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  margin-bottom: 5px;

  input {
    flex-grow: 1;
    margin-right: 5px;
  }

  > * {
    margin-right: 5px;
  }

  :last-child {
    margin: 0;
  }

  .btn-default .glyphicon {
    position: relative;
    top: 2px;
  }
}
</style>
